import * as React from 'react';
export const EmptyDocuments = (props: React.SVGProps<SVGSVGElement>) => (
  <svg className="EmptyDocuments" viewBox="0 0 16 16" {...props}>
    <path d="M10,0H2v16h12V4L10,0z M10,1.4L12.6,4H10V1.4z M13,15H3V1h6v4h4V15z" />
  </svg>
);
export default EmptyDocuments;
